<ng-template #template>
  <li role="option" [key2click]="{ processEsc: false, disableTabStop: model.disableTabStop }" [visible]="listModel.isItemVisible(model)" [class]="class" [attr.id]="elementId" [attr.aria-selected]="ariaSelected ? 'true' : 'false'" (click)="click($event)" (pointerdown)="pointerdown($event)">
    <ng-container *ngIf="model.needSeparator">
    <div [class]="listModel.cssClasses.itemSeparator"></div>
    </ng-container>
    <div [class]="listModel.cssClasses.itemBody" [style]="itemStyle" [attr.title]="model.getTooltip()"
    (mouseover)="listModel.onItemHover(model)"
    (mouseleave)="listModel.onItemLeave(model)">
    <ng-template [component]="{ name: itemComponent, data: { model: model, listModel: listModel } }"></ng-template>
    </div>
  </li>
</ng-template>